import { createPortal } from "react-dom";

import { capitalize } from "@/ds";

import type { GanttTipProps } from "./types-gantt-tip";
import styles from "./gantt-tip.module.scss";

export function GanttTipView({ tip }: GanttTipProps) {
  if (!tip) return null;

  const { card, id, style, cardRef } = tip;
  const compact = card.phases.length === 0;
  const badgeTone = card.badgeTone ?? "danger";

  return createPortal(
    <div
      ref={cardRef}
      id={id}
      role="tooltip"
      className={`${styles.card} ${compact ? styles.compact : ""}`}
      style={style}
      data-testid="gantt-tip-card"
    >
      <div className={styles.header}>
        <div className={styles.titleRow}>
          <p className={styles.title}>{card.title}</p>
          {card.badge ? (
            <span
              className={`${styles.badge} ${styles[`badge${capitalize(badgeTone)}`]}`}
              data-testid="gantt-tip-badge"
            >
              {card.badge}
            </span>
          ) : null}
        </div>
        {card.subtitle ? <p className={styles.subtitle}>{card.subtitle}</p> : null}
      </div>

      {card.phases.length > 0 ? (
        <div className={styles.phases}>
          {card.phases.map((phase) => (
            <div key={phase.label} className={styles.phase} data-testid="gantt-tip-phase">
              <span
                className={`${styles.swatch} ${styles[`tone${capitalize(phase.tone)}`]}`}
                aria-hidden
              />
              <span className={styles.phaseLabel}>{phase.label}</span>
              <span className={styles.period}>{phase.periodo}</span>
              <span className={styles.days}>{phase.dias}</span>
            </div>
          ))}
        </div>
      ) : null}

      {card.facts && card.facts.length > 0 ? (
        <div className={styles.facts}>
          {card.facts.map((fact) => (
            <div key={fact.label} className={styles.fact} data-testid="gantt-tip-fact">
              <span className={styles.factLabel}>{fact.label}</span>
              <span className={styles.factValue}>{fact.value}</span>
            </div>
          ))}
        </div>
      ) : null}

      {card.total ? (
        <>
          <hr className={styles.divider} />
          <div className={styles.total} data-testid="gantt-tip-total">
            <span className={styles.totalLabel}>Período total</span>
            <span className={styles.period}>{card.total.periodo}</span>
            <span className={styles.days}>{card.total.dias}</span>
          </div>
        </>
      ) : null}
    </div>,
    document.body,
  );
}
